import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchProductsAction } from "../../redux/slices/products/productSlices";
import baseURL from "../../utils/baseURL";   
import ErrorMsg from "../ErrorMessage/ErrorMsg";                    
import Skeleton from "../Skeleton/Skeleton";
import { getOptimizedImage } from '../../utils/cloudinary';

const HomeProductTrending = () => {
  const dispatch = useDispatch();
  const productUrl = `${baseURL}/products`;

  useEffect(() => {
    dispatch(fetchProductsAction({ url: productUrl }));
  }, [dispatch]);

const productsData = useSelector((state) => state?.products);
const products = productsData?.products?.products || [];
const loading = productsData?.loading || false;
const error = productsData?.error || null;

  const productList = products || [];      // safe array

  return (
    <section aria-labelledby="trending-heading">
      <div className="mx-auto max-w-7xl py-24 px-4 sm:px-6 sm:py-32 lg:px-8 lg:pt-32">
        <div className="md:flex md:items-center md:justify-between">
          <h2 id="favorites-heading" className="text-2xl font-bold tracking-tight text-gray-900">
            Las más vendidas
          </h2>
          <Link
            to="/products-filters"
            className="hidden text-sm font-semibold text-indigo-600 hover:text-indigo-500 sm:block"
          >
            Ver todo <span aria-hidden="true"> &rarr;</span>
          </Link>
        </div>

        {/* Loading / Error / Content */}
                {loading ? (
                    <div className="mt-6 grid grid-cols-2 gap-x-4 gap-y-10 sm:gap-x-6 md:grid-cols-4 md:gap-y-0 lg:gap-x-8">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="space-y-3">
                <Skeleton className="aspect-square w-full rounded-md" />
                <Skeleton className="h-4 w-3/4" />
                <Skeleton className="h-3 w-1/2" />
                <Skeleton className="h-5 w-1/3" />
              </div>
            ))}
          </div>
        ) : error ? (
          <ErrorMsg message={error?.message} />
        ) : productList.length === 0 ? (
          <p className="mt-6 text-gray-500">No products found</p>
        ) : (
          <div className="mt-6 grid grid-cols-2 gap-x-4 gap-y-10 sm:gap-x-6 md:grid-cols-4 md:gap-y-0 lg:gap-x-8">
            {productList.map((product) => (
              <Link
                to={`/products/${product._id}`}
                key={product._id}
                className="group relative"
              >
                <div className="h-56 w-full overflow-hidden rounded-md group-hover:opacity-75 lg:h-72 xl:h-80">
                  <img
                      src={getOptimizedImage(product.images[0], { width: 400, height: 400 })}
                      alt={product.name}
                    />
                </div>
                <h3 className="mt-4 text-sm text-gray-700">
                  <span className="absolute inset-0" />
                  {product.name}
                </h3>
                <p className="mt-1 text-sm font-medium text-gray-900">
                  ${product.price}.00
                </p>
                <p className="mt-1 text-sm text-gray-500">{product.description}</p>
              </Link>
            ))}
          </div>
        )}

        <div className="mt-8 text-sm md:hidden">
          <Link
            to="/products-filters"
            className="text-sm font-semibold text-indigo-600 hover:text-indigo-500"
          >
            Ver todo <span aria-hidden="true"> &rarr;</span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HomeProductTrending;